// import { useState } from "react";
// import { AddCommentService } from "../../../services/MainScreen";

// export default function CommentProductComponent({productId}) {
//   const [isLoadingAddComment, setIsLoadingAddComment] = useState(false);
//   const handelSumbitComment = async () => {
//     const response = await AddCommentService("", productId, 5);
//     // const response = await AddCommentService(comment, productId, rate);
//   };
//   return (
//     <>
//       <div className="product-commenting">
//         <h3 className="product-commenting-title">دیدگاه خود را بنویسید</h3>
//         <form
//           name="commenting"
//           className="product-commenting-form"
//           onSubmit={handelSumbitComment}
//         >
//           {/* <div className="alert alert-danger validation-summary product-commenting-failed">
//             <h6 className="alert-heading text-xs validation-summary-title product-commenting-failed-title">
//               ghrgfh
//             </h6>
//             <ul className="validation-summary-list text-xxs product-commenting-failed-list">
//               <li className="validation-summary-item product-commenting-failed-item">
//                 jutyjhgj
//               </li>
//             </ul>
//           </div>
//           <div className="alert alert-success product-commenting-succeed">
//             fghkghkf
//           </div>
//           <div className="product-commenting-reply-info">
//             <div className="alert alert-warning">
//               این دیدگاه به عنوان پاسخ شما به دیدگاهی دیگر ارسال خواهد شد. برای
//               صرف نظر از ارسال این پاسخ، بر روی گزینه‌ی
//               <u>انصراف</u> کلیک کنید.
//             </div>
//           </div> */}
//           <div className="row">
//             {/* <div className="col-md-12"> */}
//             <div className="col-12 col-md-8">
//               <div className="form-group product-commenting-body">
//                 <textarea
//                   id="productcomment-body"
//                   name="body"
//                   className="form-control product-commenting-body-input"
//                   rows={6}
//                   placeholder="بنویسید..."
//                 />
//                 <div className="validation-inline product-commenting-inline-error text-danger">
//                   <span>دیدگاه خود را بنویسید.</span>
//                   <span>
//                     <span />
//                   </span>
//                 </div>
//               </div>
//             </div>
//             {/* <div className="col-md-6 col-lg-4">
//               <div className="form-group product-commenting-name">
//                 <label className="form-control-label product-commenting-name-label">
//                   نام و نام خانوادگی
//                 </label>
//                 <input
//                   type="text"
//                   id="productcomment-name"
//                   name="name"
//                   className="form-control product-commenting-name-input"
//                 />
//                 <div className="validation-inline product-commenting-inline-error text-danger">
//                   <span>
//                     <span />
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-6 col-lg-4">
//               <div className="form-group product-commenting-email">
//                 <label className="form-control-label product-commenting-email-label">
//                   پست الکترونیک
//                 </label>
//                 <input
//                   type="text"
//                   id="productcomment-email"
//                   name="email"
//                   className="form-control product-commenting-email-input"
//                 />
//                 <div className="validation-inline product-commenting-inline-error text-danger">
//                   <span>
//                     <span />
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-6 col-lg-4">
//               <div className="form-group product-commenting-website">
//                 <label className="form-control-label product-commenting-website-label">
//                   آدرس وب‌سایت
//                 </label>
//                 <input
//                   type="text"
//                   id="productcomment-website"
//                   name="website"
//                   className="form-control product-commenting-website-input"
//                 />
//                 <div className="validation-inline product-commenting-inline-error text-danger">
//                   <span>
//                     <span />
//                   </span>
//                 </div>
//               </div>
//             </div> */}
//             <div className="col-12 col-md-4">
//               <div className="form-group product-commenting-rate">
//                 <label className="form-control-label product-commenting-rate-label">
//                   امتیاز شما به محصول
//                 </label>
//                 <select
//                   id="productcomment-rate"
//                   name="rate"
//                   className="form-control product-commenting-rate-input"
//                 >
//                   <option>یک ستاره</option>
//                   <option>دو ستاره</option>
//                   <option>سه ستاره</option>
//                   <option>چهار ستاره</option>
//                   <option>پنج ستاره</option>
//                 </select>
//                 <div className="validation-inline product-commenting-inline-error text-danger">
//                   <span>
//                     <span />
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <button
//             className="btn btn-primary product-commenting-submit rounded"
//             style={{
//               backgroundColor: "#369dae !important",
//             }}
//           >
//             ارسال دیدگاه
//           </button>
//           {/* <button className="btn btn-primary product-commenting-submit">
//             ارسال پاسخ
//           </button> */}
//           <button
//             type="button"
//             className="btn btn-link product-commenting-reset"
//             style={{ color: "#369dae !important" }}
//           >
//             انصراف
//           </button>
//           {isLoadingAddComment ? (
//             <div className="product-commenting-loading">
//               <i className="fa fa-refresh fa-spin fa-fw" />
//               کمی صبر کنید...
//             </div>
//           ) : null}
//         </form>
//       </div>
//     </>
//   );
// }

import { useState } from "react";
import { AddCommentService } from "../../../services/MainScreen";
import { BASE_URL, RETURNURLLOGIN_URL_LOCAL } from "../../../utility/BaseUrl";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { isTokenValid } from "../../../utility/Cookies";

export default function CommentProductComponent({  productData }) {
  function convertJalaliToGregorian(dateString) {
    const [year, month, day] = dateString.split("-").map(Number);
    const gregorianDate = new Date(year + 621, month - 1, day);
    return gregorianDate;
  }
  return (
    <div className="product-comments">
      <div>
        {/*<if terms="yep">
                              <div class="product-commenting">
                                  <h3 class="product-commenting-title mb-15 mb-sm-20 mb-md-25">
                                      دیدگاه خود را بنویسید
                                  </h3>
                                  <form name="commenting" class="product-commenting-form"
                                        ng-submit="commenting.$valid && submit()" dynamic-form novalidate>
                                      <scope name="product-commenting">
                                          <div class="alert alert-danger validation-summary -failed" ng-if="validation" ng-class="{'d-block' : validation}">
    <h6 class="alert-heading text-xs validation-summary-title -failed-title">
  <span ng-bind="validation.main"></span>
    </h6>
    <ul class="validation-summary-list text-xxs -failed-list">
  <li class="validation-summary-item -failed-item" ng-repeat="(key, value) in validation" ng-if="key != 'main'">
      {{value}}
  </li>
    </ul>
</div>
                                      </scope>
                                      <div class="alert alert-success product-commenting-succeed"
                                           ng-show="succeed">
                                          <span ng-bind="succeed.description"></span>
                                      </div>
                                      <div class="product-commenting-reply-info" ng-show="isreply"
                                           ng-click="focusComment()">
                                          <div class="alert alert-warning">
                                              این دیدگاه به عنوان پاسخ شما به دیدگاهی دیگر ارسال خواهد شد. برای
                                              صرف نظر از ارسال این پاسخ، بر روی گزینه‌ی
                                              <u>انصراف</u> کلیک کنید.
                                          </div>
                                      </div>
                                      <div class="row mx-n2">
                                          <if terms="nope">
                                              <div class="col-12 px-2 mb-15 text-xs">
                                                  دیدگاه شما از طرف
                                                  <mark></mark>
                                                  ارسال خواهد شد.
                                              </div>
                                          </if>
                                          <if terms="yep">
                                              <div class="col-12 col-sm-6 col-lg-3 px-2">
                                                  <div class="form-group product-commenting-name">
                                                      <input type="text" id="productcomment-name" name="name"
                                                             class="form-control product-commenting-name-input text-xs"
                                                             ng-model="model.name" ng-disabled="progress"
                                                             placeholder="نام و نام خانوادگی">
                                                      <div class="validation-inline product-commenting-inline-error text-danger"
                                                           ng-messages="commenting.name.$error"
                                                           ng-show="commenting.$submitted || commenting.name.$dirty">
																<span ng-message="server">
																	<span ng-bind="validation.name"></span>
																</span>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="col-12 col-sm-6 col-lg-3 px-2">
                                                  <div class="form-group product-commenting-email">
                                                      <input type="text" id="productcomment-email" name="email"
                                                             class="form-control product-commenting-email-input text-xs"
                                                             ng-model="model.email"
                                                             ng-disabled="progress" placeholder="پست الکترونیکی">
                                                      <div class="validation-inline product-commenting-inline-error text-danger"
                                                           ng-messages="commenting.email.$error"
                                                           ng-show="commenting.$submitted || commenting.email.$dirty">
																<span ng-message="server">
																	<span ng-bind="validation.email"></span>
																</span>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="col-12 col-sm-6 col-lg-3 px-2">
                                                  <div class="form-group product-commenting-website">
                                                      <input type="text" id="productcomment-website"
                                                             name="website"
                                                             class="form-control product-commenting-website-input text-xs"
                                                             ng-model="model.website"
                                                             ng-disabled="progress" placeholder="آدرس وب‌سایت">
                                                      <div class="validation-inline product-commenting-inline-error text-danger"
                                                           ng-messages="commenting.website.$error"
                                                           ng-show="commenting.$submitted || commenting.website.$dirty">
																<span ng-message="server">
																	<span ng-bind="validation.website"></span>
																</span>
                                                      </div>
                                                  </div>
                                              </div>
                                          </if>
                                          <if terms="yep">
                                              <div class="col-12 col-sm-6 col-lg-3 px-2">
                                                  <div class="form-group product-commenting-rate">
                                                      <select id="productcomment-rate" name="rate"
                                                              class="form-control product-commenting-rate-input text-xs"
                                                              ng-model="model.rate" ng-disabled="progress">
                                                          <option ng-value="">امتیاز شما به محصول</option>
                                                          <option ng-value="1">یک ستاره</option>
                                                          <option ng-value="2">دو ستاره</option>
                                                          <option ng-value="3">سه ستاره</option>
                                                          <option ng-value="4">چهار ستاره</option>
                                                          <option ng-value="5">پنج ستاره</option>
                                                      </select>
                                                      <div class="validation-inline product-commenting-inline-error text-danger"
                                                           ng-messages="commenting.rate.$error"
                                                           ng-show="commenting.$submitted || commenting.rate.$dirty">
																<span ng-message="server">
																	<span ng-bind="validation.rate"></span>
																</span>
                                                      </div>
                                                  </div>
                                              </div>
                                          </if>


                                          <div class="col-12 px-2">
                                              <div class="form-group product-commenting-body">
                                                  <textarea id="productcomment-body" name="body"
                                                            class="form-control product-commenting-body-input text-xs"
                                                            rows="6" placeholder="بنویسید..."
                                                            ng-model="model.body" ng-disabled="progress"
                                                            required></textarea>
                                                  <div class="validation-inline product-commenting-inline-error text-danger"
                                                       ng-messages="commenting.body.$error"
                                                       ng-show="commenting.$submitted || commenting.body.$dirty">
															<span ng-message="required">
																دیدگاه خود را بنویسید.
															</span>
                                                      <span ng-message="server">
																<span ng-bind="validation.body"></span>
															</span>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                      <button class="btn btn-primary product-commenting-submit"
                                              ng-disabled="progress" ng-hide="isreply">
                                          ارسال دیدگاه
                                      </button>
                                      <button class="btn btn-primary product-commenting-submit"
                                              ng-disabled="progress" ng-show="isreply">
                                          ارسال پاسخ
                                      </button>
                                      <button type="button" class="btn btn-link product-commenting-reset"
                                              ng-disabled="progress" ng-show="commenting.$dirty"
                                              ng-click="reset()"
                                              click-confirm="همه‌ی اطلاعات نوشته شده، حذف می‌شوند. آیا مطمئن هستید؟">
                                          انصراف
                                      </button>
                                      <div class="product-commenting-loading" ng-show="progress">
                                          <i class="fa fa-refresh fa-spin fa-fw"></i>
                                          کمی صبر کنید...
                                      </div>
                                  </form>
                              </div>
                          </if>*/}
        <div className="product-comments pb-35 pb-sm-45 pb-md-60" id="comments">
          {productData.comments
            .sort(
              (a, b) =>
                convertJalaliToGregorian(b.created_at) -
                convertJalaliToGregorian(a.created_at)
            )
            .map((item, index) => {
              if (!item.is_active) return;
              const stars = Array.from({ length: item.rate }, (_, i) => (
                <span key={i} className="ml-1">
                  <i className="fa fa-star product-comment-rate-icon d-block" />
                </span>
              ));
              return (
                <CommentViewBox
                  key={index}
                  image={item.user.image}
                  fullName={item.user.name + " " + item.user.family}
                  stars={stars}
                  comment={item.comment}
                  created_at={item.created_at}
                />
              );
            })}
        </div>

        {isTokenValid() ? (
          <AddCommentForProduct productId={productData.product.id} />
        ) : null}
      </div>
    </div>
  );
}

export const CommentViewBox = ({
  image,
  fullName,
  stars,
  comment,
  created_at,
}) => {
  return (
    <div className="product-comment post-full-comment">
      <div className="product-comment-inner rounded">
        <div className="product-comment-header p-20 pb-sm-25 px-sm-30 pt-sm-30">
          <div className="row mx-n10 align-items-center">
            <div className="col-auto d-none d-sm-block px-10 post-plain-comment-avatar">
              <img
                src={BASE_URL + image}
                alt={fullName}
                title={fullName}
                className="product-comment-avatar-image post-plain-comment-avatar-image"
              />
            </div>
            <div className="col px-10">
              <div className="d-flex align-items-center mt-1">
                <h5
                  className="product-comment-author post-full-comment-author text-lg mb-0"
                  itemProp="author"
                  itemScope
                  itemType="http://schema.org/Person"
                >
                  <meta itemProp="url" content />
                  <span
                    className="product-comment-name post-full-comment-name"
                    itemProp="name"
                  >
                    {fullName}
                  </span>
                </h5>
                {/* <a
                                      href="javascript:;"
                                      className="text-primary mr-10 product-comment-reply post-full-comment-reply"
                                      ng-click="reply(113220387)"
                                    >
                                      <i className="fa fa-reply" />
                                    </a> */}
              </div>
              <span className="product-comment-time post-full-comment-time text-muted d-block text-xxs">
                {created_at}
              </span>
            </div>
            <div className="col-auto px-10">
              <div className="product-comment-rate text-warning d-flex ml-n1">
                {stars}
              </div>
            </div>
          </div>
        </div>
        <p
          className="p-20 pt-sm-25 px-sm-30 pb-sm-30 mb-0 text-xs product-comment-body post-full-comment-body break-word"
          dangerouslySetInnerHTML={{
            __html: comment,
          }}
        />
      </div>
    </div>
  );
};

export const AddCommentForProduct = ({ productId }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [comment, setComment] = useState("");
  const [rate, setRate] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoadingAddComment, setIsLoadingAddComment] = useState(false);

  const handleSubmitComment = async (e) => {
    e.preventDefault();

    const validationErrors = {};
    if (!comment) validationErrors.comment = "دیدگاه خود را بنویسید.";
    if (!rate) validationErrors.rate = "لطفاً امتیاز خود را انتخاب کنید.";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setIsLoadingAddComment(true);

    try {
      const response = await AddCommentService(comment, productId, rate);
      if (response.status === 401)
        return Swal.fire({
          icon: "warning",
          title: "هشدار!",
          text: "توکن شما منقضی شده! لطفا دوباره وارد سیستم شوید!",
          confirmButtonText: "فهمیدم!",
        }).then((result) => {
          if (result.isConfirmed)
            navigate(RETURNURLLOGIN_URL_LOCAL(location.pathname));
        });
      if (response.status === 200) {
        setComment("");
        setRate("");

        return Swal.fire({
          icon: "success",
          title: "",
          text: response.message,
          confirmButtonText: "فهمیدم!",
        });
      }

      return Swal.fire({
        icon: "error",
        title: "",
        text: response.message,
        confirmButtonText: "فهمیدم!",
      });
    } catch (error) {
      return Swal.fire({
        icon: "error",
        title: "",
        text: "مشکلی پیش آمده است، لطفاً دوباره تلاش کنید.",
        confirmButtonText: "فهمیدم!",
      });
    } finally {
      setIsLoadingAddComment(false);
    }
  };

  return (
    <div className="product-commenting">
      <h3 className="product-commenting-title">دیدگاه خود را بنویسید</h3>
      <form
        name="commenting"
        className="product-commenting-form"
        onSubmit={handleSubmitComment}
      >
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="form-group product-commenting-body">
              <textarea
                id="productcomment-body"
                name="body"
                className="form-control product-commenting-body-input"
                rows={6}
                placeholder="بنویسید..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
              {errors.comment && (
                <div className="validation-inline product-commenting-inline-error text-danger">
                  <span>{errors.comment}</span>
                </div>
              )}
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="form-group product-commenting-rate">
              <label className="form-control-label product-commenting-rate-label">
                امتیاز شما به محصول
              </label>
              <select
                id="productcomment-rate"
                name="rate"
                className="form-control product-commenting-rate-input"
                value={rate}
                onChange={(e) => setRate(e.target.value)}
              >
                <option value="">انتخاب کنید...</option>
                <option value="1">یک ستاره</option>
                <option value="2">دو ستاره</option>
                <option value="3">سه ستاره</option>
                <option value="4">چهار ستاره</option>
                <option value="5">پنج ستاره</option>
              </select>
              {errors.rate && (
                <div className="validation-inline product-commenting-inline-error text-danger">
                  <span>{errors.rate}</span>
                </div>
              )}
            </div>
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-primary product-commenting-submit rounded"
          style={{
            backgroundColor: "#369dae !important",
          }}
          disabled={isLoadingAddComment}
        >
          ارسال دیدگاه
        </button>
        <button
          type="button"
          className="btn btn-link product-commenting-reset"
          style={{ color: "#369dae !important" }}
          onClick={() => {
            setComment("");
            setRate("");
            setErrors({});
          }}
        >
          انصراف
        </button>
        {isLoadingAddComment && (
          <div className="product-commenting-loading">
            <i className="fa fa-refresh fa-spin fa-fw" />
            کمی صبر کنید...
          </div>
        )}
      </form>
    </div>
  );
};

{
  /* <div class="product-comments">
                            <div eval="collect(155479376)" product-commenting="" auto-show="" class="ng-scope" style="display: block;">
                                
                                    <div class="product-comments pb-35 pb-sm-45 pb-md-60" id="comments">
                                        
                                            <div class="product-comment post-full-comment" id="comment-113220387" itemprop="comment" itemscope="" itemtype="http://schema.org/Comment">
                                                <div class="product-comment-inner rounded">
                                                    <div class="product-comment-header p-20 pb-sm-25 px-sm-30 pt-sm-30">
                                                        <div class="row mx-n10 align-items-center">
                                                            <div class="col-auto d-none d-sm-block px-10 post-plain-comment-avatar">
                                                                <img src="/site/resources/avatars/empty.jpg?m=crop&amp;w=60&amp;h=60&amp;q=high" class="product-comment-avatar-image post-plain-comment-avatar-image">
                                                            </div>
                                                            <div class="col px-10">
                                                                <div class="d-flex align-items-center mt-1">
                                                                    <h5 class="product-comment-author post-full-comment-author text-lg mb-0" itemprop="author" itemscope="" itemtype="http://schema.org/Person">
                                                                        
                                                                        <meta itemprop="url" content="">
                                                                        
                                                                <span class="product-comment-name post-full-comment-name" itemprop="name">
                                                                    ابراهیم مرتضوی
                                                                </span>
                                                                        
                                                                        
                                                                    </h5>
                                                                    <a href="javascript:;" class="text-primary mr-10 product-comment-reply post-full-comment-reply" ng-click="reply(113220387)">
                                                                        <i class="fa fa-reply"></i>
                                                                    </a>
                                                                </div>

                                                                <span class="product-comment-time post-full-comment-time text-muted d-block text-xxs">
                                                            <meta itemprop="dateCreated" content="2021-06-09">
                                                            1253 روز پیش
                                                        </span>
                                                            </div>
                                                            <div class="col-auto px-10">

                                                                
                                                                    <div class="product-comment-rate text-warning d-flex ml-n1">
                                                                        <!-- ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] -->
                                                                    </div>
                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p class="p-20 pt-sm-25 px-sm-30 pb-sm-30 mb-0 text-xs product-comment-body post-full-comment-body break-word" itemprop="text">
                                                        یکی از بهترین و فوق العاده ترین اسپیکرهای موجود تو بازاره واقعا از لحاظ کیفیت و کوالیتی معرکس
                                                    </p>
                                                </div>
                                                
                                            </div>
                                        
                                            <div class="product-comment post-full-comment" id="comment-113221111" itemprop="comment" itemscope="" itemtype="http://schema.org/Comment">
                                                <div class="product-comment-inner rounded">
                                                    <div class="product-comment-header p-20 pb-sm-25 px-sm-30 pt-sm-30">
                                                        <div class="row mx-n10 align-items-center">
                                                            <div class="col-auto d-none d-sm-block px-10 post-plain-comment-avatar">
                                                                <img src="/site/resources/avatars/empty.jpg?m=crop&amp;w=60&amp;h=60&amp;q=high" class="product-comment-avatar-image post-plain-comment-avatar-image">
                                                            </div>
                                                            <div class="col px-10">
                                                                <div class="d-flex align-items-center mt-1">
                                                                    <h5 class="product-comment-author post-full-comment-author text-lg mb-0" itemprop="author" itemscope="" itemtype="http://schema.org/Person">
                                                                        
                                                                        <meta itemprop="url" content="">
                                                                        
                                                                <span class="product-comment-name post-full-comment-name" itemprop="name">
                                                                    حسینی
                                                                </span>
                                                                        
                                                                        
                                                                    </h5>
                                                                    <a href="javascript:;" class="text-primary mr-10 product-comment-reply post-full-comment-reply" ng-click="reply(113221111)">
                                                                        <i class="fa fa-reply"></i>
                                                                    </a>
                                                                </div>

                                                                <span class="product-comment-time post-full-comment-time text-muted d-block text-xxs">
                                                            <meta itemprop="dateCreated" content="2021-06-12">
                                                            1250 روز پیش
                                                        </span>
                                                            </div>
                                                            <div class="col-auto px-10">

                                                                
                                                                    <div class="product-comment-rate text-warning d-flex ml-n1">
                                                                        <!-- ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] -->
                                                                    </div>
                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p class="p-20 pt-sm-25 px-sm-30 pb-sm-30 mb-0 text-xs product-comment-body post-full-comment-body break-word" itemprop="text">
                                                        با اختلاف بهترین و با کیفیت ترین باند برای تمامی کارهاس
                                                    </p>
                                                </div>
                                                
                                            </div>
                                        
                                            <div class="product-comment post-full-comment" id="comment-113221473" itemprop="comment" itemscope="" itemtype="http://schema.org/Comment">
                                                <div class="product-comment-inner rounded">
                                                    <div class="product-comment-header p-20 pb-sm-25 px-sm-30 pt-sm-30">
                                                        <div class="row mx-n10 align-items-center">
                                                            <div class="col-auto d-none d-sm-block px-10 post-plain-comment-avatar">
                                                                <img src="/site/resources/avatars/empty.jpg?m=crop&amp;w=60&amp;h=60&amp;q=high" class="product-comment-avatar-image post-plain-comment-avatar-image">
                                                            </div>
                                                            <div class="col px-10">
                                                                <div class="d-flex align-items-center mt-1">
                                                                    <h5 class="product-comment-author post-full-comment-author text-lg mb-0" itemprop="author" itemscope="" itemtype="http://schema.org/Person">
                                                                        
                                                                        <meta itemprop="url" content="">
                                                                        
                                                                <span class="product-comment-name post-full-comment-name" itemprop="name">
                                                                    موسوی
                                                                </span>
                                                                        
                                                                        
                                                                    </h5>
                                                                    <a href="javascript:;" class="text-primary mr-10 product-comment-reply post-full-comment-reply" ng-click="reply(113221473)">
                                                                        <i class="fa fa-reply"></i>
                                                                    </a>
                                                                </div>

                                                                <span class="product-comment-time post-full-comment-time text-muted d-block text-xxs">
                                                            <meta itemprop="dateCreated" content="2021-06-13">
                                                            1249 روز پیش
                                                        </span>
                                                            </div>
                                                            <div class="col-auto px-10">

                                                                
                                                                    <div class="product-comment-rate text-warning d-flex ml-n1">
                                                                        <!-- ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] -->
                                                                    </div>
                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p class="p-20 pt-sm-25 px-sm-30 pb-sm-30 mb-0 text-xs product-comment-body post-full-comment-body break-word" itemprop="text">
                                                        تکنولوژی و شاهکار آلمان
                                                    </p>
                                                </div>
                                                
                                            </div>
                                        
                                            <div class="product-comment post-full-comment" id="comment-113237147" itemprop="comment" itemscope="" itemtype="http://schema.org/Comment">
                                                <div class="product-comment-inner rounded">
                                                    <div class="product-comment-header p-20 pb-sm-25 px-sm-30 pt-sm-30">
                                                        <div class="row mx-n10 align-items-center">
                                                            <div class="col-auto d-none d-sm-block px-10 post-plain-comment-avatar">
                                                                <img src="/site/resources/avatars/empty.jpg?m=crop&amp;w=60&amp;h=60&amp;q=high" class="product-comment-avatar-image post-plain-comment-avatar-image">
                                                            </div>
                                                            <div class="col px-10">
                                                                <div class="d-flex align-items-center mt-1">
                                                                    <h5 class="product-comment-author post-full-comment-author text-lg mb-0" itemprop="author" itemscope="" itemtype="http://schema.org/Person">
                                                                        
                                                                        <meta itemprop="url" content="">
                                                                        
                                                                <span class="product-comment-name post-full-comment-name" itemprop="name">
                                                                    reza yazdani
                                                                </span>
                                                                        
                                                                        
                                                                    </h5>
                                                                    <a href="javascript:;" class="text-primary mr-10 product-comment-reply post-full-comment-reply" ng-click="reply(113237147)">
                                                                        <i class="fa fa-reply"></i>
                                                                    </a>
                                                                </div>

                                                                <span class="product-comment-time post-full-comment-time text-muted d-block text-xxs">
                                                            <meta itemprop="dateCreated" content="2021-07-29">
                                                            1203 روز پیش
                                                        </span>
                                                            </div>
                                                            <div class="col-auto px-10">

                                                                
                                                                    <div class="product-comment-rate text-warning d-flex ml-n1">
                                                                        <!-- ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] --><span ng-repeat="number in [1,2,3,4,5]" class="ml-1 ng-scope">
                                                                            <i class="fa fa-star product-comment-rate-icon d-block" ng-class="{ 'fa-star-o': number > 5 }"></i>
                                                                        </span><!-- end ngRepeat: number in [1,2,3,4,5] -->
                                                                    </div>
                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p class="p-20 pt-sm-25 px-sm-30 pb-sm-30 mb-0 text-xs product-comment-body post-full-comment-body break-word" itemprop="text">
                                                        معرکس واقعا بینظیره شاهکار المان حرف نداره و بی رقیب
                                                    </p>
                                                </div>
                                                
                                            </div>
                                        
                                            <div class="product-comment post-full-comment" id="comment-113343293" itemprop="comment" itemscope="" itemtype="http://schema.org/Comment">
                                                <div class="product-comment-inner rounded">
                                                    <div class="product-comment-header p-20 pb-sm-25 px-sm-30 pt-sm-30">
                                                        <div class="row mx-n10 align-items-center">
                                                            <div class="col-auto d-none d-sm-block px-10 post-plain-comment-avatar">
                                                                <img src="/site/resources/avatars/empty.jpg?m=crop&amp;w=60&amp;h=60&amp;q=high" class="product-comment-avatar-image post-plain-comment-avatar-image">
                                                            </div>
                                                            <div class="col px-10">
                                                                <div class="d-flex align-items-center mt-1">
                                                                    <h5 class="product-comment-author post-full-comment-author text-lg mb-0" itemprop="author" itemscope="" itemtype="http://schema.org/Person">
                                                                        
                                                                        <meta itemprop="url" content="">
                                                                        
                                                                <span class="product-comment-name post-full-comment-name" itemprop="name">
                                                                    ناشناس
                                                                </span>
                                                                        
                                                                        
                                                                    </h5>
                                                                    <a href="javascript:;" class="text-primary mr-10 product-comment-reply post-full-comment-reply" ng-click="reply(113343293)">
                                                                        <i class="fa fa-reply"></i>
                                                                    </a>
                                                                </div>

                                                                <span class="product-comment-time post-full-comment-time text-muted d-block text-xxs">
                                                            <meta itemprop="dateCreated" content="2022-04-14">
                                                            944 روز پیش
                                                        </span>
                                                            </div>
                                                            <div class="col-auto px-10">

                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p class="p-20 pt-sm-25 px-sm-30 pb-sm-30 mb-0 text-xs product-comment-body post-full-comment-body break-word" itemprop="text">
                                                        سلام برای فضای باز پرتاب صدا داره
                                                    </p>
                                                </div>
                                                
                                            </div>
                                        
                                            <div class="product-comment post-full-comment" id="comment-113435663" itemprop="comment" itemscope="" itemtype="http://schema.org/Comment">
                                                <div class="product-comment-inner rounded">
                                                    <div class="product-comment-header p-20 pb-sm-25 px-sm-30 pt-sm-30">
                                                        <div class="row mx-n10 align-items-center">
                                                            <div class="col-auto d-none d-sm-block px-10 post-plain-comment-avatar">
                                                                <img src="/site/resources/avatars/empty.jpg?m=crop&amp;w=60&amp;h=60&amp;q=high" class="product-comment-avatar-image post-plain-comment-avatar-image">
                                                            </div>
                                                            <div class="col px-10">
                                                                <div class="d-flex align-items-center mt-1">
                                                                    <h5 class="product-comment-author post-full-comment-author text-lg mb-0" itemprop="author" itemscope="" itemtype="http://schema.org/Person">
                                                                        
                                                                        <meta itemprop="url" content="">
                                                                        
                                                                <span class="product-comment-name post-full-comment-name" itemprop="name">
                                                                    آرش تهمتن
                                                                </span>
                                                                        
                                                                        
                                                                    </h5>
                                                                    <a href="javascript:;" class="text-primary mr-10 product-comment-reply post-full-comment-reply" ng-click="reply(113435663)">
                                                                        <i class="fa fa-reply"></i>
                                                                    </a>
                                                                </div>

                                                                <span class="product-comment-time post-full-comment-time text-muted d-block text-xxs">
                                                            <meta itemprop="dateCreated" content="2022-11-23">
                                                            720 روز پیش
                                                        </span>
                                                            </div>
                                                            <div class="col-auto px-10">

                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p class="p-20 pt-sm-25 px-sm-30 pb-sm-30 mb-0 text-xs product-comment-body post-full-comment-body break-word" itemprop="text">
                                                        خدای بانده باید حتما داشته باشی تا متوجه بشی قدرت صدا یعنی چی👊👊
                                                    </p>
                                                </div>
                                                
                                            </div>
                                        
                                    </div>
                                
                        
								
									<div class="product-commenting">
										
											<hr class="page-separator product-separator product-commenting-separator">
										
										<h3 class="product-commenting-title">
											دیدگاه خود را بنویسید
										</h3>
										<form name="commenting" class="product-commenting-form ng-invalid ng-invalid-required ng-dirty ng-valid-parse" ng-submit="commenting.$valid &amp;&amp; submit()" dynamic-form="" novalidate="">
											
												<!-- ngIf: validation -->
											
											<div class="alert alert-success product-commenting-succeed ng-hide" ng-show="succeed">
												<span ng-bind="succeed.description" class="ng-binding"></span>
											</div>
											<div class="product-commenting-reply-info ng-hide" ng-show="isreply" ng-click="focusComment()">
												<div class="alert alert-warning">
													این دیدگاه به عنوان پاسخ شما به دیدگاهی دیگر ارسال خواهد شد. برای صرف نظر از ارسال این پاسخ، بر روی گزینه‌ی
													<u>انصراف</u> کلیک کنید.
												</div>
											</div>
											<div class="row">
												<div class="col-md-12">
													<div class="form-group product-commenting-body">
														<textarea id="productcomment-body" name="body" class="form-control product-commenting-body-input ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required" rows="6" placeholder="بنویسید..." ng-model="model.body" ng-disabled="progress" required=""></textarea>
														<div class="validation-inline product-commenting-inline-error text-danger ng-active ng-hide" ng-messages="commenting.body.$error" ng-show="commenting.$submitted || commenting.body.$dirty">
															<!-- ngMessage: required --><span ng-message="required" class="ng-scope">
																دیدگاه خود را بنویسید.
															</span>
															<!-- ngMessage: server -->
														</div>
													</div>
												</div>
												
													<div class="col-md-6 col-lg-4">
														<div class="form-group product-commenting-name">
															<label for="productcomment-name" class="form-control-label product-commenting-name-label">
																نام و نام خانوادگی
															</label>
															<input type="text" id="productcomment-name" name="name" class="form-control product-commenting-name-input ng-pristine ng-untouched ng-valid ng-empty" ng-model="model.name" ng-disabled="progress">
															<div class="validation-inline product-commenting-inline-error text-danger ng-inactive ng-hide" ng-messages="commenting.name.$error" ng-show="commenting.$submitted || commenting.name.$dirty">
																<!-- ngMessage: server -->
															</div>
														</div>
													</div>
													<div class="col-md-6 col-lg-4">
														<div class="form-group product-commenting-email">
															<label for="productcomment-email" class="form-control-label product-commenting-email-label">
																پست الکترونیک
															</label>
															<input type="text" id="productcomment-email" name="email" class="form-control product-commenting-email-input ng-pristine ng-untouched ng-valid ng-empty" ng-model="model.email" dir="ltr" ng-disabled="progress">
															<div class="validation-inline product-commenting-inline-error text-danger ng-inactive ng-hide" ng-messages="commenting.email.$error" ng-show="commenting.$submitted || commenting.email.$dirty">
																<!-- ngMessage: server -->
															</div>
														</div>
													</div>
													<div class="col-md-6 col-lg-4">
														<div class="form-group product-commenting-website">
															<label for="productcomment-website" class="form-control-label product-commenting-website-label">
																آدرس وب‌سایت
															</label>
															<input type="text" id="productcomment-website" name="website" class="form-control product-commenting-website-input ng-pristine ng-untouched ng-valid ng-empty" ng-model="model.website" dir="ltr" ng-disabled="progress">
															<div class="validation-inline product-commenting-inline-error text-danger ng-inactive ng-hide" ng-messages="commenting.website.$error" ng-show="commenting.$submitted || commenting.website.$dirty">
																<!-- ngMessage: server -->
															</div>
														</div>
													</div>
												
												
													<div class="col-md-6 col-lg-4">
														<div class="form-group product-commenting-rate">
															<label for="productcomment-rate" class="form-control-label product-commenting-rate-label">
																امتیاز شما به محصول
															</label>
															<select id="productcomment-rate" name="rate" class="form-control product-commenting-rate-input ng-untouched ng-valid ng-empty ng-dirty ng-valid-parse" ng-model="model.rate" ng-disabled="progress"><option value="? undefined:undefined ?" selected="selected"></option>
																<option ng-value="1" value="number:1">یک ستاره</option>
																<option ng-value="2" value="number:2">دو ستاره</option>
																<option ng-value="3" value="number:3">سه ستاره</option>
																<option ng-value="4" value="number:4">چهار ستاره</option>
																<option ng-value="5" value="number:5">پنج ستاره</option>
															</select>
															<div class="validation-inline product-commenting-inline-error text-danger ng-inactive" ng-messages="commenting.rate.$error" ng-show="commenting.$submitted || commenting.rate.$dirty">
																<!-- ngMessage: server -->
															</div>
														</div>
													</div>
												
												
											</div>
											<button class="btn btn-primary product-commenting-submit rounded" ng-disabled="progress" ng-hide="isreply" style="background-color: rgb(54, 157, 174) !important; --darkreader-inline-bgcolor: #2b7e8b;" data-darkreader-inline-bgcolor="">
												ارسال دیدگاه
											</button>
											<button class="btn btn-primary product-commenting-submit ng-hide" ng-disabled="progress" ng-show="isreply">
												ارسال پاسخ
											</button>
											<button type="button" class="btn btn-link product-commenting-reset" ng-disabled="progress" ng-show="commenting.$dirty" ng-click="reset()" click-confirm="همه‌ی اطلاعات نوشته شده، حذف می‌شوند. آیا مطمئن هستید؟" style="color: rgb(54, 157, 174) !important; --darkreader-inline-color: #5ebdcd;" data-darkreader-inline-color="">
												انصراف
											</button>
											<div class="product-commenting-loading ng-hide" ng-show="progress">
												<i class="fa fa-refresh fa-spin fa-fw"></i>
												کمی صبر کنید...
											</div>
										</form>
									</div>
								
                            </div>
                        </div> */
}
